import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormControl } from '@material-ui/core';
import { getModalSwitch, getLoaderBtn, handleUpdateUserAttribute, handleAddUserAttribute } from '@app/store/actions';

import { useTypedTranslation } from '@app/hooks';
import { ModalActionsComponent, PasslyTextField } from '@app/components';
import { FormMode } from '@app/helpers/enums';
import { onPressEnterModal, genericErrorString } from '@app/helpers';

export interface IReceivedData {
    formMode: FormMode;
    userId: string;
    attributeId: string;
    attributeName: string;
    attributeValue: string;
}

export default function AddEditUserAttributeDialog(props: IReceivedData) {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [attributeName, setAttributeName] = useState(props.attributeName);
    const [attributeValue, setAttributeValue] = useState(props.attributeValue);
    const [errorMessage, setErrorMessage] = useState('');

    const onFormChange = (e: any) => {
        const { name, value } = e.target;

        switch (name) {
            case 'attributeName':
                setAttributeName(value);
                break;
            case 'attributeValue':
                setAttributeValue(value);
                break;
            default:
                break;
        }
    };

    const validateForm = () => {
        if (attributeName !== '') {
            return true;
        }

        return false;
    };

    const handleSubmitBtn = () => {
        dispatch(getLoaderBtn(true));

        const valid: boolean = validateForm();

        if (!valid) {
            setErrorMessage(translation('ATTRIBUTE_NAME') + ' ' + translation('IS_REQUIRED'));

            dispatch(getLoaderBtn(false));
            return;
        }

        if (props.formMode === FormMode.Add) {
            dispatch(handleAddUserAttribute(props.userId, attributeName, attributeValue, handleError));
        } else if (props.formMode === FormMode.Edit) {
            dispatch(handleUpdateUserAttribute(props.userId, props.attributeId, attributeName, attributeValue, handleError));
        }
    };

    const handleError = (error: any) => {
        dispatch(getLoaderBtn(false));
        setErrorMessage(genericErrorString(error));
    };

    const handleCancel = () => {
        dispatch(getModalSwitch(false));
        dispatch(getLoaderBtn(false));
    };

    return (
        <>
            <form className='modal__form modal__medium' method='post' tabIndex={0} onKeyPress={onPressEnterModal(handleSubmitBtn)}>
                <FormControl className='modal__form--password'>
                    <PasslyTextField fullWidth id='attributeName-input' label={'ATTRIBUTE_KEY'} name='attributeName' value={attributeName} onChange={onFormChange} autoFocus required />
                </FormControl>

                <FormControl className='modal__form--password'>
                    <PasslyTextField fullWidth id='attributeValue-input' label={'ATTRIBUTE_VALUE'} name='attributeValue' value={attributeValue} onChange={onFormChange} required />
                </FormControl>

                {errorMessage && (
                    <p>
                        <div className='modal__error'>{errorMessage}</div>
                    </p>
                )}
            </form>
            <ModalActionsComponent
                primaryBtn={translation('OK')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={handleSubmitBtn}
                onClickSecondary={handleCancel}
                id='addEditAttributes'
            />
        </>
    );
}
